



























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import ProgressTrackerDesktop from './ProgressTracker.vue';
// validations
import { required, email, sameAs, minLength, numeric } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';
import { captureException as SentryCaptureException } from '@sentry/browser';
import Loading from '@/components/Global/Loading.vue';

@Component({
	name: 'VerifyPhone',
	components: {
		TextField,
		Alert,
		Validation,
		SelectField,
		RadioField,
		Base,
		Welcome,
		Checkbox,
		ProgressTrackerDesktop,
		Loading,
	},
	validations: {
		form: {
			code: {
				required,
				numeric,
			},
		},
	},
})
export default class VerifyPhone extends Vue {
	private form: any;

	@Prop(Object) private config!: any;
	private error: string | boolean;
	private logger: any;
	private loading: boolean;
	private isInvalid: boolean;
	private newCodeSent: boolean;
	constructor() {
		super();

		this.form = {
			code: '',
		};
		this.newCodeSent = false;
		this.loading = false;
		this.isInvalid = false;
		this.error = false;
	}

	private isInValid() {
		return this.$v.$invalid;
	}

	get options(): any {
		const defaults = {
			phoneNumber: '',
		};
		return Object.assign(defaults, this.$route.params.config || {});
	}

	get details() {
		return Brand.getBrandInformation();
	}

	private confirm() {
		this.error = false;
		this.isInvalid = false;
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.isInvalid = true;
			window.scrollTo(0, 0);
			return;
		}
		const that = this;
		this.$Amplify.Auth.verifyCurrentUserAttributeSubmit('phone_number', this.form.code)
			.then(() => {
				that.signedIn();
			})
			.catch(e => {
				SentryCaptureException(e);
			});
	}

	private async signedIn() {
		this.loading = true;
		const session = await this.$Amplify.Auth.currentSession();

		this.$store
			.dispatch('Auth/authenticated', {
				// @ts-ignore
				accessToken: session.accessToken.jwtToken,
				// @ts-ignore
				idToken: session.idToken.jwtToken,
				// @ts-ignore
				refreshToken: session.refreshToken.token,
				expiresIn: null,
				tokenType: null,
			})
			.then(
				response => {
					this.$router.push({
						name: 'home',
					});
				},
				error => {
					this.$router.push({
						name: 'login',
						params: {
							error: true,
						},
					});
				},
			);
	}

	private requestNewCode() {
		this.loading = false;
		this.$Amplify.Auth.verifyCurrentUserAttribute('phone_number')
			.then(() => {
				console.log('new code sent');
				this.newCodeSent = true;
				this.loading = false;
			})
			.catch(e => {
				this.loading = false;
				SentryCaptureException(e);
			});
	}
	private signIn() {
		this.$router.push({
			name: 'login',
		});
	}

	private setError(e) {
		window.scrollTo(0, 0);
	}
}
